import MultChoiceObj from "../Models/QTypes/MultChoiceObj";
// import CheckboxObj from '../Models/QTypes/CheckboxObj';

const Talent_QSet = [
  new MultChoiceObj({
    questionSet: {
      English: "How do you measure the efficiency of your candidate pipeline?",
    },
    answerSet: {
      English: [
        "Our candidate analysis process does not measure effectiveness.",
        "We analyze recruiting effectiveness on an ad hoc basis after the fact.",
        "Our HR system reports standard metrics for evaluating candidates’ insights.",
        "Our Talent acquisition analytics provides key metrics and actionable recruiting.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you evaluate compensation trends?",
    },
    answerSet: {
      English: [
        "We currently do standard compensation reporting only.",
        "We download data for ad-hoc identification of compensation trends.",
        "Standalone HR system provides basic compensation trend and compa-ratio analysis.",
        "Integrated compensation trending and compa-ratio analysis with projections.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "Which best describes how you analyze workforce retention and measure joiners & leavers?",
    },
    answerSet: {
      English: [
        "Our process uses spreadsheet reports for tracking attrition and retention.  predict future attrition rates.",
        "Turnover and retention reports are created in standard BI tools.",
        "Attrition is tracked with our HCM system dashboards.",
        "Analytics system visualizes turnover drivers, with embedded ML to predict future attrition rates.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "How do you correlate (what do you do to define or identify these groups) talent and compensation?",
    },
    answerSet: {
      English: [
        "We do not have a method for correlating top talent and compensation.",
        "We use manual solutions to analyze talent by department.",
        "We analyze talent performance at a corporate level.",
        "We leverage a unified analytics system to correlate compensation to top talent performance.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English: "How do you track employee career mobility?",
    },
    answerSet: {
      English: [
        "We report on individual career moves in annual review discussions.",
        "Department managers track employee mobility as needed.",
        "Corporate historical employee moves reported in our HCM system.",
        "Top internal mobility factors are tracked at the employee level with Analytics.",
      ],
    },
  }),
  new MultChoiceObj({
    questionSet: {
      English:
        "How do you currently assess performance and goals (make more time for me to get to know my employees and give more productive feedback)?",
    },
    answerSet: {
      English: [
        "Ad-hoc processes performed by each department as needed.",
        "Informal process with periodic evaluation and coordination across departments.",
        "Formal process, partially automated with periodic evaluation.",
        "Fully automated analysis to assess performance of individuals and teams against business goals.",
      ],
    },
  }),
];

export default Talent_QSet;
